import { preview } from '@/components/form/preview'
import { useTexts } from './hooks/useTexts'
import { BulkViewData } from '../../hooks/useBulkViewData/types'

type Props = {
  bulkData: BulkViewData
}

export function Email(props: Props) {
  const {
    bulkData: { email },
  } = props

  const texts = useTexts()

  return (
    <preview.Field label={texts.contactInformation.email.label}>
      {email === 'mixed' ? (
        <preview.MixValue />
      ) : email.length === 0 ? (
        <preview.NullValue />
      ) : (
        email
      )}
    </preview.Field>
  )
}
